import { Component, Directive } from "@angular/core"
import { select, Store } from "@ngrx/store"
import { combineLatest, Subscription } from "rxjs"
import { filter } from "rxjs/operators"
import { loadUserFavorites } from "../../ngrx/home-actions"
import { isFavoritesLoaded, selectCards, selectFavorites } from "../../ngrx/home-selectors"

export interface IFavoritesBaseClass{
    requestCardsAndFavoritesIfNotExist(): void
    loadCardsAndFavorites(): void
}

@Directive({})
export abstract class FavoritesBaseClass implements IFavoritesBaseClass{
    private favoritesSubscriptions = new Subscription();
    constructor(
        protected store: Store
    ){}

    requestCardsAndFavoritesIfNotExist(){
        this.favoritesSubscriptions.add(
            this.store.pipe(
                select(isFavoritesLoaded),
                filter(status => status == false),
            ).subscribe(() => {
                this.store.dispatch(loadUserFavorites())
            })
        );
    }

    loadCardsAndFavorites(){
        return combineLatest(
            [
              this.store.pipe(
                select(selectFavorites)
              ),
              this.store.pipe(
                select(selectCards)
              ),
            ]
        )
    }

    unsubscribeFromFavoriteOps(){
        this.favoritesSubscriptions.unsubscribe();
    }
}